import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Permission.List.IRequest;
type Response = Api.Core.Permission.List.IResponse;
type Headers = Api.Core.Permission.List.IHeaders;
const url = '/api/Management/Permission';
export default async function permissionListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
